<div class="footer" fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="20px">
  <div class="footer-text">© 2022 Constellation Energy Resources, LLC. All rights reserved.
  </div>
</div>
